/**
 * Free Remotion Template Component
 * ---------------------------------
 * This template is free to use in your projects!
 * Credit appreciated but not required.
 *
 * Created by the team at https://www.reactvideoeditor.com
 *
 * Happy coding and building amazing videos! 🎉
 */

"use client";

import { useCurrentFrame, spring, useVideoConfig } from "remotion";

export default function LogoFadeReveal() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Logo fade + scale using spring
  const logoProgress = spring({
    frame,
    fps,
    config: { damping: 12, stiffness: 80, mass: 0.8 },
  });

  const logoOpacity = logoProgress;
  const logoScale = 0.8 + 0.2 * logoProgress;

  // Company name fades in with delay
  const textProgress = spring({
    frame: Math.max(0, frame - 15),
    fps,
    config: { damping: 14, stiffness: 60, mass: 0.6 },
  });

  const textOpacity = textProgress;
  const textTranslateY = 20 * (1 - textProgress);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Logo */}
      <div
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "24px",
          background: "linear-gradient(135deg, #4361ee, #7209b7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: logoOpacity,
          transform: `scale(${logoScale})`,
          boxShadow: "0 0 40px rgba(67, 97, 238, 0.3)",
        }}
      >
        <span
          style={{
            color: "white",
            fontSize: "1.8rem",
            fontWeight: "800",
            letterSpacing: "0.1em",
            fontFamily: "Inter, sans-serif",
          }}
        >
          LOGO
        </span>
      </div>

      {/* Company Name */}
      <h2
        style={{
          color: "white",
          fontSize: "2rem",
          fontWeight: "700",
          marginTop: "1.5rem",
          marginBottom: 0,
          fontFamily: "Inter, sans-serif",
          letterSpacing: "0.05em",
          opacity: textOpacity,
          transform: `translateY(${textTranslateY}px)`,
        }}
      >
        Company Name
      </h2>
      <p
        style={{
          color: "#93c5fd",
          fontSize: "1rem",
          marginTop: "0.5rem",
          fontFamily: "Inter, sans-serif",
          opacity: textOpacity,
          transform: `translateY(${textTranslateY}px)`,
        }}
      >
        Your tagline here
      </p>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
